import {styled} from "@mui/material";

export const AppBarSpacer = styled('div')(({ theme }) => theme.mixins.toolbar);
